/* eslint eqeqeq: 0 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import Modal from '../Modal';
import * as modal from '../../reducers/modalReducer';
import CloseIcon from '../CloseIcon';
import { TextDiv } from '../../modals';
import { getDispensaryName } from '../../selectors/configSelectors';
import { CONTAINER_HEIGHT, FormWrapperDiv, STYLES } from './styles';
import './style.css';

class ReachOutUsToResetPasswordModal extends Component {
  secondaryColor = `#${this.props.secondaryColor}`;

  onCloseRequest = () => {
    this.props.hideModal();
  }

  render() {
    return (
      <Modal paddingTop="65px" overlayTop={0} closeOnOverlayClick closeOnOutsideClick={false} isOpened onClose={this.onCloseRequest}>
        <div name="resetPasswordform" style={{ margin: '20px 0' }}>
          <div onClick={this.onCloseRequest} style={STYLES.closeIconWrap}><CloseIcon style={STYLES.closeIcon} /></div>
          <FormWrapperDiv style={{ height: CONTAINER_HEIGHT }}>
            <TextDiv> {`Please reach out to ${this.props.dispensaryName} to reset your password.`} </TextDiv>
            <div style={{ marginTop: '10px' }}>
              <RaisedButton
                onClick={this.onCloseRequest}
                backgroundColor={`#${this.props.secondaryColor}`}
                labelColor="#FFF"
                labelStyle={STYLES.labelStyle}
                label="OK"
              />
            </div>
          </FormWrapperDiv>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  primaryColor: state.config.primaryColor,
  secondaryColor: state.config.secondaryColor,
  dispensaryName: getDispensaryName(state),
});

const mapDispatchToProps = dispatch => ({
  hideModal: () => dispatch(modal.hideModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReachOutUsToResetPasswordModal);



// WEBPACK FOOTER //
// ./src/components/ResetPasswordModal/ReachOutUsToResetPasswordModal.js